module.exports = __webpack_public_path__ + "static/media/homepage-empty-preview.eea94000.svg";